import { render, staticRenderFns } from "./CompanyDesktopReserved.vue?vue&type=template&id=0dd789df"
import script from "./CompanyDesktopReserved.vue?vue&type=script&lang=js"
export * from "./CompanyDesktopReserved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports